<template>
  <div class="exchange_alert">
    <div class="exchange_alert_wrap">
      <div class="exchange_alert_close" @click="hideExchangeAlert"></div>
      <div
        class="exchange_alert_body"
        v-if="
          isExchangeSuccess &&
          (goods.type_extra == 'phone_30' ||
            goods.type_extra == 'phone_50' ||
            goods.type_extra == 'phone_100')
        "
      >
        <div class="exchange_alert_img">
          <img :src="goods.large_img" />
        </div>
        <div class="exchange_phone_success">
          <div class="exchange_phone_success_title">充值中</div>
          <div class="exchange_phone_success_desc">
            充值结果将于短信方式通知您
          </div>
        </div>
        <div class="exchange_phone_success_btn" @click="hideExchangeAlert">
          确 认
        </div>
      </div>
      <div class="exchange_alert_body" v-else>
        <div class="exchange_alert_success" v-if="isExchangeSuccess">
          兑换成功
        </div>
        <div class="exchange_alert_failed" v-if="isShowFailed">
          <div>兑换失败</div>
          <div
            class="exchange_alert_failed_tips"
            v-if="goods.category == 'phone'"
          >
            运营商接口出错，积分已返还至您的账户，请稍后再试
          </div>
          <div class="exchange_alert_failed_tips" v-else>
            积分已返还至您的账户<br />请稍后再试
          </div>
        </div>
        <div class="exchange_alert_failed" v-if="isShowOutOfStock">
          会员卡已兑完
        </div>
        <div class="exchange_alert_img">
          <img :src="goods.large_img" />
        </div>
        <div class="exchange_alert_info">
          <div class="exchange_alert_name">{{ goods.name }}</div>
          <div class="exchange_alert_points">
            消耗积分：{{ goods.points }}积分
          </div>
        </div>
        <div
          class="exchange_alert_code"
          v-if="isExchangeSuccess && goods.type == ''"
        >
          兑换码: {{ code }}
        </div>
        <div
          class="exchange_alert_fuluzc"
          v-if="isExchangeSuccess && zcTypes.includes(goods.type)"
        >
          已充值到：{{ phoneOrEmail }}
        </div>
        <div
          class="exchange_alert_disable"
          v-if="goods.type == 'kdts' && !isCanExchange"
        >
          当前宽带不支持大鹏提速
        </div>
        <div
          class="exchange_alert_enable"
          v-else-if="goods.type == 'kdts' && !isExchangeSuccess"
        >
          将自动充值到您的账号ID：{{ $store.state.user.uid }}
        </div>
        <div
          class="exchange_alert_enable"
          v-else-if="goods.type == 'kdts' && isExchangeSuccess"
        >
          已充值到：{{ $store.state.user.uid }}
        </div>
      </div>

      <div
        class="phone-box"
        v-if="
          !isExchangeSuccess &&
          !isShowFailed &&
          zcTypes.includes(goods.type) &&
          isCanExchange
        "
      >
        <div v-if="!isShowPhoneConfirm">
          <div
            v-if="
              goods.type_extra == '10005308' || goods.type_extra == '10005304'
            "
          >
            <div class="warmText">提醒：将直充到QQ号关联的账号</div>
            <input
              type="text"
              placeholder="请输入正确的QQ号"
              v-model="phoneOrEmail"
            />
            <div class="error-text" v-if="isShowPhoneError">
              * 账号错误，请重新输入
            </div>
          </div>
          <div v-else>
            <div class="warmText">提醒：将直充到手机号关联的账号</div>
            <input
              type="text"
              placeholder="请输入正确的手机号"
              v-model="phoneOrEmail"
            />
            <div class="error-text" v-if="isShowPhoneError">
              * 账号错误，请重新输入
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-if="
              goods.type_extra == '10005308' || goods.type_extra == '10005304'
            "
          >
            <div class="phone_confirm_tips">请确认充值QQ号码</div>
            <div class="phone_confirm">{{ phoneOrEmail }}</div>
          </div>
          <div v-else>
            <div class="phone_confirm_tips">请确认充值手机号码</div>
            <div class="phone_confirm">{{ phoneOrEmail }}</div>
          </div>
        </div>
      </div>

      <div
        class="waiting-box-bg"
        v-if="
          !isExchangeSuccess &&
          !isShowFailed &&
          goods.type != 'kdts' &&
          isCanExchange &&
          isShowLoading
        "
      >
        <div class="waiting-box">
          <img :src="exchangeAlert_loading" />
        </div>
      </div>

      <div
        :class="{
          exchange_alert_btn: true,
          exchange_alert_btn_disable: !isCanExchange,
        }"
        @click="exchange"
        v-if="
          !isExchangeSuccess &&
          !isShowFailed &&
          !isShowOutOfStock &&
          !zcTypes.includes(goods.type)
        "
      >
        确认兑换
      </div>

      <div
        :class="{
          exchange_alert_btn: true,
          exchange_alert_btn_disable: !isCanExchange,
        }"
        @click="exchangeFuluZc"
        v-if="
          !isExchangeSuccess &&
          !isShowFailed &&
          !isShowOutOfStock &&
          zcTypes.includes(goods.type) &&
          !isShowPhoneConfirm
        "
      >
        确认兑换
      </div>

      <div
        class="phone_confirm_btns"
        v-if="
          !isExchangeSuccess &&
          !isShowFailed &&
          !isShowOutOfStock &&
          zcTypes.includes(goods.type) &&
          isShowPhoneConfirm
        "
      >
        <div
          @click="exchangeFuluZcCancel"
          class="phone_confirm_btn phone_confirm_cancel"
        >
          重填
        </div>
        <div
          @click="exchangeFuluZcConfirm"
          class="phone_confirm_btn phone_confirm_sure"
        >
          确认
        </div>
      </div>

      <!-- <div
				class="exchange_jump_kdts"
				v-else-if="
					goods.type == 'kdts' &&
					isExchangeSuccess &&
					!isShowOutOfStock
				"
				@click="jumpKdts"
			>
				立即查看 >>
			</div> -->

      <div
        class="exchange_alert_btn exchange_alert_btn_disable"
        v-if="isShowOutOfStock"
      >
        补货中
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: function () {
    return {
      zcTypes: ["fuluzc", "hongtaizc"],
      code: "",
      isExchangeSuccess: false,
      isShowOutOfStock: false,
      isShowFailed: false,
      isCanExchange: false,
      phoneOrEmail: "",
      isShowPhoneError: false,
      isShowPhoneConfirm: false,
      isCheckPhone: false,
      isShowLoading: false,
      fuluQueryInterval: null,
      fuluQueryIntervalCount: 0,
      exchangeAlert_loading: require("../assets/mall/exchangeAlert_loading.png"),
    };
  },
  props: ["goods"],
  watch: {
    isShowFailed: function (newVal) {
      let _that = this;
      if (newVal) {
        setTimeout(function () {
          // _that.isShowFailed = false;
        }, 2000);
      }
    },
    isShowPhoneError: function (newVal) {
      let _that = this;
      if (newVal) {
        setTimeout(function () {
          _that.isShowPhoneError = false;
        }, 1500);
      }
    },
  },
  methods: {
    ...mapActions([
      "exchangeGoods",
      "getUserInfo",
      "getKdtsInfo",
      "fuluOrder",
      "fuluQuery",
      "sendUserlog",
    ]),
    hideExchangeAlert: function () {
      //this.$store.state.isShowExchangeAlert = false;
      this.$emit("close");
    },
    exchangeFuluZcCancel: function () {
      let _that = this;
      _that.isShowPhoneConfirm = false;
      _that.isCheckPhone = false;
    },
    exchangeFuluZcConfirm: function () {
      let _that = this;
      _that.isCheckPhone = true;
      _that.exchangeFuluZc();
    },
    exchangeFuluZc: function () {
      let _that = this;
      if (!_that.isCanExchange) {
        return;
      }

      if (_that.phoneOrEmail == "") {
        _that.isShowPhoneError = true;
        return;
      }

      //验证规则：11位数字，以1开头。
      let regex = /^1\d{10}$/;

      // qq号规则
      if (
        _that.goods.type_extra == "10005308" ||
        _that.goods.type_extra == "10005304"
      ) {
        regex = /^[1-9][0-9]{4,9}$/;
      }

      if (!regex.test(_that.phoneOrEmail)) {
        _that.isShowPhoneError = true;
        return;
      }

      if (!_that.isCheckPhone) {
        _that.isShowPhoneConfirm = true;
        return;
      }

      _that.isShowLoading = true;

      let reqData = {
        charge_account: _that.phoneOrEmail,
        uid: parseInt(_that.$store.state.user.uid),
        gid: _that.goods.gid,
        owcode: _that.$store.state.user.owcode,
        buy_num: 1,
      };

      _that.fuluOrder([
        reqData,
        function (err, data) {
          if (err) {
            _that.isShowFailed = true;
            _that.isShowLoading = false;
            return console.log(err);
          }
          if (data.rtn == 0 && data.data.out_trade_no) {
            let outTradeNO = data.data.out_trade_no;
            if (
              _that.goods.type_extra == "phone_30" ||
              _that.goods.type_extra == "phone_50" ||
              _that.goods.type_extra == "phone_100"
            ) {
              _that.isExchangeSuccess = true;
              _that.updateUserInfo();
            } else {
              _that.startFuluQuery(outTradeNO);
            }
          } else {
            _that.isShowLoading = false;
            _that.isShowFailed = true;
          }
        },
      ]);
    },
    startFuluQuery: function (out_trade_no) {
      let _that = this;
      let reqData = {
        uid: parseInt(_that.$store.state.user.uid),
        out_trade_no: out_trade_no,
        owcode: _that.$store.state.user.owcode,
      };

      _that.fuluQueryInterval = setInterval(function () {
        _that.fuluQuery([
          reqData,
          function (err, data) {
            _that.fuluQueryIntervalCount++;
            if (err) {
              return console.log(err);
            }
            if (data.rtn == 0 && data.data.trade_state == "success") {
              _that.isExchangeSuccess = true;
              _that.fuluQueryIntervalCount = 0;
              clearInterval(_that.fuluQueryInterval);
              _that.updateUserInfo();
              _that.sendUserlog(["exchange_success", JSON.stringify(data)]);
            } else {
              if (data.data.trade_state == "failed") {
                _that.sendUserlog(["exchange_failed", JSON.stringify(data)]);
              }
              if (
                _that.fuluQueryIntervalCount > 300 ||
                data.data.trade_state == "failed"
              ) {
                _that.fuluQueryIntervalCount = 0;
                clearInterval(_that.fuluQueryInterval);
                _that.isShowLoading = false;
                _that.isShowFailed = true;
              }
            }
          },
        ]);
      }, 1000);
    },
    exchange: function () {
      let _that = this;
      if (!_that.isCanExchange) {
        return;
      }

      _that.isShowLoading = true;

      let reqData = {
        uid: _that.$store.state.user.uid,
        gid: _that.goods.gid,
        owcode: _that.$store.state.user.owcode,
      };

      _that.exchangeGoods([
        reqData,
        function (err, data) {
          if (err) {
            _that.isShowFailed = true;
            return console.log(err);
          }

          _that.isShowLoading = false;

          if (data.rtn === 0) {
            _that.code = data.data.code;
            _that.isExchangeSuccess = true;
            _that.updateUserInfo();
          } else {
            // console.log("failed");
            _that.isShowFailed = true;
          }
        },
      ]);
    },
    updateUserInfo: function () {
      let _that = this;
      let reqData = {
        uid: _that.$store.state.user.uid,
      };
      _that.getUserInfo([
        reqData,
        function (err, data) {
          if (err) {
            return console.log(err);
          }
        },
      ]);
    },
    jumpKdts: function () {
      window.location.href = "/kdsj/?appid=owdl";
    },
  },
  mounted: function () {
    let _that = this;
    if (_that.goods.type == "kdts") {
      _that.isCanExchange = false;
      _that.getKdtsInfo([
        function (err, data) {
          // console.log(data);
          if (!err && data && data.data.basic_down < data.data.target_down) {
            _that.isCanExchange = true;
          }
        },
      ]);
    } else if (
      _that.zcTypes.includes(_that.goods.type) &&
      _that.goods.stock <= 0
    ) {
      _that.isShowOutOfStock = true;
    } else {
      _that.isCanExchange = true;
    }
  },
};
</script>

<style lang="less" scoped>
.exchange_alert {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
  .exchange_alert_wrap {
    width: 250px;
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, 0);
    background-color: #ffffff;
    border-radius: 5px;
    padding-top: 40px;
    padding-bottom: 20px;

    .exchange_alert_close {
      width: 14px;
      height: 14px;
      position: absolute;
      right: 10px;
      top: 10px;
      background-image: url(../assets/mall/exchange_alert_close.png);
      background-size: 100% 100%;
      background-position: center center;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    .exchange_alert_body {
      border-radius: 5px;
      text-align: center;
      overflow: hidden;
      .exchange_alert_img {
        width: 180px;
        height: 100px;
        background-color: #cccccc;
        margin: 0 auto;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0 0 4px #cccccc;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .exchange_phone_success {
        background-color: #f9f9f9;
        text-align: center;
        width: 210px;
        margin: 10px auto;
        padding: 25px 0;
        .exchange_phone_success_title {
          color: #333333;
          font-size: 16px;
          font-weight: bolder;
        }
        .exchange_phone_success_desc {
          color: #666666;
          font-size: 13px;
          margin-top: 10px;
        }
      }
      .exchange_phone_success_btn {
        width: 190px;
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        margin-top: 20px;
        border-radius: 15px;
        color: #ffffff;
        background-color: #fda74c;
        background-image: linear-gradient(to bottom, #fda74c, #f98c17);
      }
      .exchange_alert_info {
        width: 180px;
        margin: 0 auto;
        background-color: #ffffff;
        font-size: 15px;
        text-align: left;

        .exchange_alert_name {
          color: #e1a011;
          font-size: 13px;
          background-image: url(../assets/mall/exchange_alert_vip.png);
          background-position: left bottom;
          background-repeat: no-repeat;
          background-size: 20px 20px;
          padding-left: 24px;
          margin-top: 20px;
        }
        .exchange_alert_points {
          color: #949494;
          font-size: 10px;
          margin-top: 5px;
        }
        .exchange_alert_code_title {
          color: #666666;
          text-align: center;
          padding: 10px 10px 5px 10px;
        }
        .exchange_alert_code_num {
          color: #fc8c15;
          text-align: center;
          padding: 0px 10px 10px 10px;
        }
      }
      .exchange_alert_code {
        text-align: left;
        color: #888fa4;
        font-size: 11px;
        padding: 10px 0;
        background-color: #f8f8f8;
        line-height: 20px;
        margin: 0 auto;
        margin-top: 20px;
        padding-left: 10px;
        display: inline-block;
        padding-right: 25px;
        background-image: url(../assets/mall/exchange_alert_copy.png);
        background-position: right 8px center;
        background-size: 12px 14px;
        background-repeat: no-repeat;
        word-break: break-all;
        max-width: 80%;
      }
      .exchange_alert_disable {
        font-size: 12px;
        color: #e51010;
        background-color: #ffffff;
        font-size: 11px;
        text-align: center;
        margin-top: 4px;
      }
      .exchange_alert_enable {
        width: 180px;
        margin: 0 auto;
        font-size: 12px;
        color: #666666;
        background-color: #ffffff;
        font-size: 11px;
        text-align: left;
        margin-top: 4px;
      }
      .exchange_alert_fuluzc {
        margin: 0 auto;
        font-size: 12px;
        color: #999999;
        background-color: #ffffff;
        font-size: 11px;
        text-align: left;
        width: 180px;
        margin-top: 10px;
      }
    }

    .phone-box {
      position: relative;
      width: 180px;
      margin: 0 auto;
      margin-top: 10px;
      color: #d8d8d8;

      .warmText {
        text-align: center;
        color: #999999;
        font-size: 10px;
      }

      input {
        margin-top: 4px;
        width: 180px;
        height: 28px;
        box-sizing: border-box;
        border: 1px solid rgba(148, 148, 148, 0.2);
        border-radius: 2px;
        text-align: center;
        font-size: 11px;
        caret-color: #121212; //改变光标颜色
      }

      .error-text {
        position: absolute;
        left: 0;
        top: 52px;
        color: #fb3535;
        font-size: 9px;
      }

      .phone_confirm_tips {
        text-align: center;
        color: #666666;
        font-size: 13px;
      }
      .phone_confirm {
        color: #666666;
        font-size: 15px;
        background-color: #f2f2f2;
        text-align: center;
        height: 35px;
        line-height: 35px;
        margin-top: 4px;
        border: 1px solid #cccccc;
        border-radius: 2px;
      }
    }

    .waiting-box-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .waiting-box {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -19px;
        margin-top: -19px;
        // transform: translate(-50%, 0);
        width: 38px;
        height: 38px;
        border-radius: 5px;
        overflow: hidden;
        background-color: #6a6a6a;

        img {
          width: 100%;
          height: 100%;
          animation: spin 2s linear infinite;
        }
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .exchange_alert_btn {
      width: 106px;
      height: 33px;
      line-height: 33px;
      margin: 0 auto;
      margin-top: 20px;
      text-align: center;
      color: #ffffff;
      box-shadow: 0 3px 6px rgba(18, 18, 18, 0.2);
      background-color: #fda74c;
      background-image: linear-gradient(to right, #fda74c, #f98c17);
      border-radius: 33px;
      cursor: pointer;
    }
    .exchange_alert_btn_disable {
      background-color: #d4d4d4;
      background-image: linear-gradient(to bottom, #d4d4d4, #b4b4b4);
      border-radius: 19px;
      overflow: hidden;
    }
    .exchange_alert_success {
      text-align: center;
      color: #fdb515;
      font-size: 18px;
      background-image: url(../assets/mall/exchange_alert_success.png);
      background-size: 23px 23px;
      background-position: left center;
      background-repeat: no-repeat;
      display: inline-block;
      padding-left: 30px;
      margin-bottom: 20px;
    }
    .exchange_alert_failed {
      color: #bb1010;
      text-align: center;
      font-size: 20px;
      margin-bottom: 20px;
      .exchange_alert_failed_tips {
        font-size: 14px;
        color: #333333;
        width: 80%;
        margin: 0 auto;
      }
    }
    .exchange_jump_kdts {
      font-size: 14px;
      color: #196ef0;
      text-align: center;
      margin-top: 10px;
      cursor: pointer;
    }

    .phone_confirm_btns {
      text-align: center;
      color: #ffffff;
      font-size: 11px;
      margin-top: 16px;
      cursor: pointer;
      .phone_confirm_btn {
        display: inline-block;
        height: 30px;
        width: 76px;
        line-height: 30px;
        border-radius: 15px;
      }
      .phone_confirm_cancel {
        background-color: #cfcfcf;
        background-image: linear-gradient(to bottom, #cfcfcf, #959595);
        margin-right: 12px;
      }
      .phone_confirm_sure {
        background-color: #fda74c;
        background-image: linear-gradient(to bottom, #fda74c, #f98c17);
      }
    }
  }
}
</style>